<template>
  <teleport to="body">
  <div
    class="fixed inset-0 flex items-center justify-center bg-backdrop"
    role="dialog"
    aria-modal="true"
    @mousedown.self="onCancel"
  >
    <div
      class="min-w-80 rounded-control bg-bg2 p-4 text-text"
    >
      <div class="mb-3 text-group font-semibold">{{ title }}</div>
      <SingleLineInput
        v-model="textValue"
        :title="textLabel"
        :placeholder="textPlaceholder"
        :initialyFocused="!initialText"
        @keyup-enter="onConfirm"
      />
      <SingleLineInput
        class="mt-3"
        v-model="value"
        :title="urlLabel"
        :placeholder="placeholder"
        :initialyFocused="!!initialText"
        @keyup-enter="onConfirm"
      />
      <div class="mt-4 flex justify-end gap-2">
        <SimpleButton variant="primary" size="md" :text="cancelText" @click="onCancel" />
        <SimpleButton variant="accent" size="md" :text="confirmText" @click="onConfirm" />
      </div>
    </div>
  </div>
  </teleport>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import SingleLineInput from '@/components/elements/SingleLineInput.vue';
import SimpleButton from '@/components/elements/SimpleButton.vue';

const props = defineProps({
  title: { type: String, default: '' },
  placeholder: { type: String, default: '' },
  initialValue: { type: String, default: '' },
  textLabel: { type: String, default: '' },
  textPlaceholder: { type: String, default: '' },
  initialText: { type: String, default: '' },
  urlLabel: { type: String, default: '' },
  cancelText: { type: String, default: 'Cancel' },
  confirmText: { type: String, default: 'OK' },
});

const emit = defineEmits(['confirm', 'cancel']);

const value = ref(props.initialValue);
const textValue = ref(props.initialText);

function onConfirm() {
  emit('confirm', { text: textValue.value, url: value.value });
}

function onCancel() {
  emit('cancel');
}

// Cancel on Escape; capture phase + stopPropagation so the surrounding
// dialog (e.g. TaskDialog's @keydown.esc) does not also react to it.
function onKeydown(e) {
  if (e.key === 'Escape') {
    e.preventDefault();
    e.stopPropagation();
    onCancel();
  }
}

onMounted(() => document.addEventListener('keydown', onKeydown, true));
onBeforeUnmount(() => document.removeEventListener('keydown', onKeydown, true));
</script>